<template>
  <div>
    <LeftSide
      :status="leftSideStatus"
      :key_distributorId="filtrateProps.distributorId"
      :key_distributorName="filtrateProps.distributorName"
      :key_status="filtrateProps.status"
      :key_code="filtrateProps.code"
      :key_type="filtrateProps.type"
      :key_ordercode="filtrateProps.orderCode"
      :key_tradecode="filtrateProps.tradeCode"
      :date_from="filtrateProps.timeFrom"
      :date_to="filtrateProps.timeTo"
      @changeStatus="changeLeftSideStatus"
      @filtrate="filtrate"
    />
    <div class="br-contentpanel" :data-min="leftSideStatus">
      <Header
        :key_distributorId="filtrateProps.distributorId"
        :key_distributorName="filtrateProps.distributorName"
        :key_status="filtrateProps.status"
        :key_code="filtrateProps.code"
        :key_type="filtrateProps.type"
        :key_ordercode="filtrateProps.orderCode"
        :key_tradecode="filtrateProps.tradeCode"
        :date_from="filtrateProps.timeFrom"
        :date_to="filtrateProps.timeTo"
        @clearKey="clearKey"
      />
      <router-view
        :first_loading="firstLoading"
        :items="items"
        @openModalRefund="openModalRefund"
        @delAdd="delAdd"
        @openModalRemark="openModalRemark"
        @openModalAudit="openModalAudit"
      ></router-view>
      <pagination
        v-if="!firstLoading"
        class="pd-x-20 pd-sm-x-30"
        :cur="page"
        :all="totalPage"
        :path="'/after-sale/'"
        :page_size_select="pageSizeSelect"
        :rows_per_page="rowsPerPage"
        :total_count="totalCount"
        @changeRPPage="changeRPPage"
        @gotoPage="toPage"
      ></pagination>
    </div>
    <api-loading :show="loading"></api-loading>
    <modalRefund :open="modalRefundOpen" :info="modalRefundInfo"></modalRefund>
    <confirmComponent
      @del_index_i="delAddress"
      :modal_id="delAddr.modalId"
      :modal_title="delAddr.title"
      :modal_text="delAddr.text"
      :del_index="delAddr.delIndex"
      :type="1"
    ></confirmComponent>
    <modalRemark
      :open="modalRemarkOpen"
      :task_info="modalRemarkInfo"
    ></modalRemark>
    <modalAudit :open="modalAuditOpen" :info="modalAuditInfo"></modalAudit>
  </div>
</template>

<script>
import LeftSide from "./left-side.vue"; //左边栏
import Header from "./header.vue"; //头
import Modal from "@components/Modal";
import { confirmComponent } from "@components/components.js"; //删除确认
import { pagination } from "@components/pagination.js"; //分页
import modalRefund from "./modal-refund.vue";
import modalRemark from "./modal-remark.vue";
import modalAudit from "./modal-audit.vue";
export default {
  data() {
    return {
      leftSideStatus: store.get("leftSideStatus"), //左边栏状态
      loading: true,
      firstLoading: true,
      items: [],
      page: this.$route.params.page ? this.$route.params.page : 1,
      pageSizeSelect: [10, 20, 50],
      rowsPerPage: parseInt(store.get("after-sale-rowsPerPage"))
        ? parseInt(store.get("after-sale-rowsPerPage"))
        : 10,
      totalPage: 0,
      totalCount: 0,
      filtrateProps: {
        distributorId: "",
        distributorName: "",
        code: "",
        status: "",
        type: "",
        orderCode: "",
        tradeCode: "",
        timeFrom: "",
        timeTo: "",
      },
      modalRefundOpen: Symbol(),
      modalRefundInfo: "",
      delAddr: {
        modalId: "modalDelAddress",
        title: this.$t("mall.关闭退款"),
        text: this.$t("mall.确定要关闭该退款信息吗"),
        delIndex: "",
      },
      modalRemarkOpen: Symbol(),
      modalRemarkInfo: "",
      modalAuditOpen: Symbol(),
      modalAuditInfo: "",
    };
  },
  components: {
    LeftSide,
    Header,
    Modal,
    pagination,
    confirmComponent,
    modalRefund,
    modalRemark,
    modalAudit,
  },
  computed: {},
  watch: {
    $route: "gotoPage",
    rowsPerPage: function () {
      store.set("after-sale-rowsPerPage", this.rowsPerPage);
    },
  },
  methods: {
    openModalAudit(i) {
      this.modalAuditOpen = Symbol();
      this.modalAuditInfo = this.items[i];
      $("#modalAuditRefund").modal("show");
    },
    openModalRemark(i) {
      this.modalRemarkOpen = Symbol();
      this.modalRemarkInfo = this.items[i];
      $("#modalRefundRemark").modal("show");
    },
    delAddress(i) {
      let delId = this.items[i].id;
      let vm = this;
      this.loading = true;
      $.api_call(
        "api.AccountDetail.closeByBuyer",
        {
          accountId: delId,
        },
        (r) => {
          vm.loading = false;
          if (r.ErrorCode == "9999") {
            vm.getList();
            $(`#${vm.delAddr.modalId}`).modal("hide");
            ShowTip(this.$t("mall.关闭退款成功"), "success");
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(vm);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    delAdd(i) {
      let vm = this;
      this.delAddr.delIndex = i;
      $("#" + this.delAddr.modalId).modal("show");
    },
    openModalRefund(i) {
      this.modalRefundOpen = Symbol();
      this.modalRefundInfo = this.items[i];
      $("#modalRefund").modal("show");
    },
    clearKey(type) {
      switch (type) {
        case "distributorName":
          this.filtrateProps.distributorName = this.filtrateProps.distributorId =
            "";
          break;
        case "date":
          this.filtrateProps.timeFrom = this.filtrateProps.timeTo = "";
          break;
        default:
          this.filtrateProps[type] = "";
          break;
      }
      this.toPage(1);
    },
    filtrate(
      distributorName,
      distributorId,
      code,
      status,
      type,
      orderCode,
      tradeCode,
      timeFrom,
      timeTo
    ) {
      this.filtrateProps.distributorName = distributorName;
      this.filtrateProps.distributorId = distributorId;
      this.filtrateProps.code = code;
      this.filtrateProps.status = status;
      this.filtrateProps.type = type;
      this.filtrateProps.orderCode = orderCode;
      this.filtrateProps.tradeCode = tradeCode;
      this.filtrateProps.timeFrom = timeFrom;
      this.filtrateProps.timeTo = timeTo;
      //筛选都回第一页
      this.toPage(1);
    },
    gotoPage() {
      this.page = this.$route.params.page ? this.$route.params.page : 1;
      this.getList();
    },
    changeRPPage(num) {
      let page = this.page;
      this.rowsPerPage = num;
      this.page = 1;
      this.$router.replace({ path: "/after-sale/" + 1 });
      if (page == 1) {
        this.getList();
      }
    },
    toPage(num) {
      let page = this.page;
      this.$router.replace({ path: "/after-sale/" + num });
      if (page == num) {
        this.getList();
      }
    },
    changeLeftSideStatus() {
      //改变左边栏状态
      this.leftSideStatus = !this.leftSideStatus;
      store.set("leftSideStatus", this.leftSideStatus);
    },
    getList(s) {
      this.loading = true;
      let params = {
        page: this.page,
        rowsPerPage: this.rowsPerPage,
        distributorId: this.filtrateProps.distributorId,
        orderCode: this.filtrateProps.orderCode,
        status: this.filtrateProps.status,
        type: this.filtrateProps.type,
        payRecordCode: this.filtrateProps.code,
        tradeCode: this.filtrateProps.tradeCode,
        timeFrom: this.filtrateProps.timeFrom,
        timeTo: this.filtrateProps.timeTo,
      };
      $.api_call("api.AccountDetail.findBySupplier", params, (r) => {
        this.loading = false;
        this.firstLoading = false;
        if (r.ErrorCode == "9999") {
          this.items = r.Data.Results;
          this.totalPage = r.Data.Pagination.totalPage;
          this.totalCount = r.Data.Pagination.totalCount;
          if (!s) $("html,body").scrollTop(0);
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
  },
  mounted() {
    //展开折叠搜索
    let user = store.get("userInfo");
    let that = this;
    if (this.$parent.sideTop) {
      if ($(".br-subleft").outerHeight() > 56) {
        $(".br-subleft").addClass("left-more ht-54 ht-auto");
        $(".br-subleft").append(
          `<a href="javascript:;" class="d-flex align-items-center more-btn"><span class=" mg-r-5 tx-info">${this.$t(
            "app.更多"
          )}</span><i aria-hidden="true" class="tx-info fa fa-angle-down"></i></a>`
        );
        $(".more-btn").on("click", function () {
          if ($(this).find("i").hasClass("fa-angle-down")) {
            $(this).find("span").text(that.$t("app.隐藏"));
            $(this).parent(".br-subleft").removeClass("ht-54");
            $(this)
              .find("i")
              .removeClass("fa-angle-down")
              .addClass("fa-angle-up");
          } else {
            $(this).find("span").text(that.$t("app.更多"));
            $(this).parent(".br-subleft").addClass("ht-54");
            $(this)
              .find("i")
              .addClass("fa-angle-down")
              .removeClass("fa-angle-up");
          }
          let bodyH = parseInt($(window).height());
          if (user.source == 9) {
            if ($("body").hasClass("side-top")) {
              let ht = $(".br-subleft").outerHeight();
              $(".body-wrap").css("height", bodyH - 340 - ht + "px");
            } else {
              $(".body-wrap").css("height", bodyH - 340 + "px");
            }
          } else {
            if ($("body").hasClass("side-top")) {
              let ht = $(".br-subleft").outerHeight();
              $(".body-wrap").css("height", bodyH - 260 - ht + "px");
            } else {
              $(".body-wrap").css("height", bodyH - 260 + "px");
            }
          }
        });
      }
    }
    this.getList();
  },
};
</script>

<style lang="less" scoped>
.nav.nav-tabs {
  .nav-item {
    background-color: #fff;
    .nav-link {
      border-bottom-color: #ddd;
    }
    .nav-link:active,
    .nav-link.active {
      border-bottom: 1px solid transparent;
      color: inherit;
      background-color: #fff;
    }
    .nav-link:focus {
      color: #868ba1;
    }
    .nav-link:hover {
      background-color: #f0f0f0;
      color: #868ba1;
    }
    .nav-link.active:hover {
      background-color: #fff;
    }
  }
}
.tab-content {
  border: 1px #ddd solid;
  border-top: none;
  padding: 0 15px;
  .tab-container.active {
    display: block;
  }
  .tab-container {
    display: none;
  }
}

.modal-content {
  .sku-list {
    h3 {
      margin-bottom: 5px;
      height: 26px;
      line-height: 26px;
      font-size: 14px;
    }
  }
  tbody {
    font-size: 12px;
  }
  .pro-info {
    display: flex;
    .img-wrap {
      margin-right: 5px;
      max-width: 60px;
      max-height: 60px;
      min-width: 60px;
      min-height: 60px;
      border: 1px #ddd solid;
      background-color: #fff;
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
    }
    .right {
      display: flex;
      flex-flow: column;
      justify-content: space-between;
      max-width: 200px;
      min-width: 200px;
      line-height: 20px;
      .pro-attr {
        display: flex;
        justify-content: space-between;
      }
    }
  }
  .table-wrap {
    margin-bottom: 15px;
  }
  .new-return-bottom {
    border-top: 1px #ddd solid;
    padding: 15px 15px 0;
  }
  textarea {
    resize: none;
  }
}
.info-wrap {
  padding-top: 15px;
  border-top: 1px solid #ddd;
}
.input-wrap {
  margin: 0 -15px;
  padding-top: 15px;
  border-top: 1px solid #ddd;
}
</style>

